import { useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, MessageCircle } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { CATALOG, CATEGORIES, IMG } from "@/lib/catalog";
import { waLink } from "@/lib/api";

export default function Services() {
  useSeo("Servicios", "Amortiguadores, rótulas, terminales, bujes, horquillas, cremallera, balatas, discos, lift spacers, soldadura de chasis y refacciones en Mérida.");
  const [cat, setCat] = useState("Todos");
  const list = CATALOG.filter((s) => cat === "Todos" || s.cat === cat);
  return (
    <>
      <PageHero eyebrow="Servicios" title="Todo para tu suspensión, dirección y frenos" image={IMG.chassis}
        subtitle="Diagnosticamos antes de cambiar piezas. Te explicamos qué necesita tu vehículo y te cotizamos sin compromiso." />
      <section className="container-x py-16">
        <div className="flex flex-wrap gap-2" role="tablist" aria-label="Categorías">
          {CATEGORIES.map((c) => (
            <button key={c} role="tab" aria-selected={cat === c} onClick={() => setCat(c)} data-testid={`services-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`rounded-full border px-4 py-2 text-sm font-semibold uppercase tracking-wider transition-colors ${cat === c ? "border-brand bg-brand text-black" : "border-line text-ink2 hover:border-brand"}`}>{c}</button>
          ))}
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {list.map((s, i) => (
            <article key={s.name} className="card-dark flex flex-col p-7 rise" style={{ animationDelay: `${i * 40}ms` }} data-testid={`service-card-${CATALOG.indexOf(s)}`}>
              <div className="flex items-center justify-between">
                <s.icon size={28} className="text-brand" />
                <span className="font-mono text-[10px] uppercase tracking-widest text-green/80">{s.cat}</span>
              </div>
              <h2 className="mt-5 text-2xl font-bold uppercase leading-tight">{s.name}</h2>
              <p className="mt-3 flex-1 text-sm text-mute">{s.desc}</p>
              <div className="mt-6 flex gap-4 text-sm font-semibold uppercase tracking-wider">
                <Link to="/citas" className="flex items-center gap-1.5 text-green hover:underline"><CalendarCheck size={15} /> Agendar</Link>
                <a href={waLink("529991919300", `Hola, quiero cotizar: ${s.name}`)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-ink2 hover:text-ink"><MessageCircle size={15} /> Cotizar</a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
